import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { motion, AnimatePresence } from 'framer-motion'
import { FaToggleOff, FaToggleOn } from 'react-icons/fa'
import styles from './GeneralDetails.module.css'
import { BASE_URL_API } from '../../References/URLs'
import AuthContext from '../../store/auth-context'
import ActiveStoreContext from '../../store/ActiveStoreContext'

const GeneralDetails = ({ configurations, configurationHandler }) => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier

    return (
        <div className={styles.mainWrapper} >
            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: 'easeOut' }}
                className={styles.container}
            >
                {/* Card Type */}
                <div className={styles.formGroup}>
                    <label className={styles.label}>
                        Membership Name
                    </label>
                    <div>
                        <input placeholder="Give it some unique name..." className={styles.nameInput} value={configurations?.name} onChange={(e) => configurationHandler('name', e.target.value)} />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>
                        Type of Card
                    </label>
                    <div>
                        {configurations?.cardTypeLabel}
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>
                        Membership Category
                    </label>
                    <div>
                        {configurations?.categoryTypeLabel}
                    </div>
                </div>

                {/* Shareability */}
                <div className={styles.shareableWrapper}>
                    <div className={styles.formGroup}>
                        <label className={styles.label}>Is Shareable?</label>
                        <button className={styles.toggleBtn} onClick={() => configurationHandler('isShareable', !configurations?.isShareable)} >
                            {configurations?.isShareable ?
                                <FaToggleOn size={25} color="#4a90e2" />
                                :
                                <FaToggleOff size={25} />
                            }
                            Is this card shareable?
                        </button>
                    </div>

                    <AnimatePresence>
                        {configurations?.isShareable && (
                            <motion.div
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: 'auto' }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.3 }}
                                className={styles.formGroup}
                            >
                                <label className={styles.label}>Max Shares</label>
                                <input
                                    type="number"
                                    value={configurations?.shareLimit}
                                    onChange={(e) =>
                                        configurationHandler('shareLimit', Number(e.target.value))
                                    }
                                    min={1}
                                    autoFocus
                                    className={styles.input}
                                />
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </motion.div>
        </div>
    )
}

export default GeneralDetails
